module.exports = __webpack_public_path__ + "img/img_web05_partner@2x.d8011fe7.png";